import { cn } from "@/lib/utils";

export function KpiCard({ label, value, sub, accent, icon: Icon, testId, className }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "bg-white border border-zinc-200 rounded-md p-4 flex flex-col gap-1 transition-colors hover:border-zinc-300",
        className
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-zinc-500">{label}</span>
        {Icon && <Icon className={cn("h-4 w-4", accent ? "text-amber-500" : "text-zinc-400")} />}
      </div>
      <div className={cn("num text-xl sm:text-2xl xl:text-3xl font-black tracking-tight break-words", accent ? "text-amber-600" : "text-zinc-950")}>
        {value}
      </div>
      {sub && <div className="text-xs text-zinc-500">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-zinc-950">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
